import { render } from "./SubSecCards.vue?vue&type=template&id=6dbeefb6&scoped=true"
import script from "./SubSecCards.vue?vue&type=script&lang=js"
export * from "./SubSecCards.vue?vue&type=script&lang=js"

import "./SubSecCards.vue?vue&type=style&index=0&id=6dbeefb6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbeefb6"]])

export default __exports__